import React from 'react';
import { useTranslation } from 'react-i18next';
import TranslationHtml from '../../TranslationHtml/TranslationHtml';
import { Button } from '../../FormComponents/Buttons/Button';
import { BaseModal } from '../BaseModal/BaseModal';

import './AcceptTermsModal.scss';
import { UserType, UserTypeEnum } from '../../../types/enums/UserTypesEnum';

type Props = {
  isOpen: boolean;
  handleCloseModal: () => void;
  userType: UserType;
};

export const AcceptTermsModal = (props: Props) => {
  const { t } = useTranslation();

  return (
    <BaseModal
      isOpen={props.isOpen}
      handleCloseModal={props.handleCloseModal}
      ariaHideApp={true}
      title="project-user.terms.title"
    >
      <div className="project-user-welcome">
        {props.userType === UserTypeEnum.Captioner ? (
          <p>{t('project-user.terms.captioner')}</p>
        ) : null}
        <TranslationHtml htmlString={t('project-user.terms.support-page')} />
      </div>
      <br /> <br />
      <p className="terms-text">{t('project-user.terms.terms')}</p>
      <Button
        translationKey="button.continue"
        variant="primary"
        color="green"
        onClick={props.handleCloseModal}
        type="button"
      />
    </BaseModal>
  );
};
